// import { motion } from "framer-motion";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { useRef } from "react";
// import gaming from '../assest/products/extra/gaming.jpg';
// import business from '../assest/products/extra/business.jpg';
// import twoinone from '../assest/products/extra/2in1.jpg';
// import ultra from '../assest/products/extra/ultrabook.jpg';
// import desk from '../assest/products/extra/desktop.jpg'

// const CategorySlider = () => {

//   const scrollRef = useRef();

//   const categories = [
//     { name: "Gaming", img: gaming },
//     { name: "Business", img: business },
//     { name: "2-in-1 Convertibles", img: twoinone },
//     { name: "UltraBook", img: ultra },
//     { name: "Desktops", img: desk},
//   ];

//   const scroll = (direction) => {
//     if (direction === "left") {
//       scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
//     } else {
//       scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
//     }
//   };

//   return (
//     <div className="container mx-auto px-4 mt-16">

//       <div className="flex gap-6 items-center">

//         {/* LEFT TEXT BLOCK */}
//         <div className="w-[250px] hidden md:block">

//           <p className="text-gray-400 text-sm">Featured</p>

//           <h2 className="text-3xl font-bold leading-tight mt-2">
//             Top categories <br /> this week
//           </h2>

//           <div className="flex gap-3 mt-6">
//             <button
//               onClick={() => scroll("left")}
//               className="w-10 h-10 border rounded-full flex items-center justify-center hover:bg-gray-100"
//             >
//               <FaChevronLeft />
//             </button>

//             <button
//               onClick={() => scroll("right")}
//               className="w-10 h-10 border rounded-full flex items-center justify-center hover:bg-gray-100"
//             >
//               <FaChevronRight />
//             </button>
//           </div>

//         </div>

//         {/* RIGHT SLIDER */}
//         <div
//           ref={scrollRef}
//           className="flex gap-6 overflow-x-auto scroll-smooth no-scrollbar"
//         >

//           {categories.map((cat, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ scale: 1.05 }}
//               className="min-w-[220px] bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition text-center cursor-pointer"
//             >

//               <img
//                 src={cat.img}
//                 className="h-28 mx-auto object-contain"
//               />

//               <p className="mt-4 font-medium">
//                 {cat.name}
//               </p>

//             </motion.div>
//           ))}

//         </div>

//       </div>

//     </div>
//   );
// };

// export default CategorySlider;
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import gaming from '../assest/products/extra/gaming.jpg';
import business from '../assest/products/extra/business.jpg';
import twoinone from '../assest/products/extra/2in1.jpg';
import ultra from '../assest/products/extra/ultrabook.jpg';
import desk from '../assest/products/extra/desktop.jpg';

const CategorySlider = () => {

  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const categories = [
    { name: "Gaming", img: gaming, query: "gaming-laptops" },
    { name: "Business", img: business, query: "business-laptops" },
    { name: "2-in-1", img: twoinone, query: "convertibles" },
    { name: "Ultrabook", img: ultra, query: "ultrabook" },
    { name: "Desktops", img: desk, query: "desktops" },
  ];

  return (
    <div className="max-w-8xl mx-auto px-4 mt-6">

      <h2 className="text-2xl md:text-3xl font-bold mb-6">
        Shop by Category
      </h2>

      {/* 💻 DESKTOP GRID */}
      {!isMobile && (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">

          {categories.map((cat, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
              onClick={() => navigate(`/product-category?category=${cat.query}`)}
              className="relative h-[160px] md:h-[200px] rounded-xl overflow-hidden cursor-pointer group"
            >
              <img
                src={cat.img}
                alt={cat.name}
                className="w-full h-full object-cover transition duration-500 group-hover:scale-105"
              />

              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition" />

              <div className="absolute bottom-3 left-3">
                <p className="text-white text-sm md:text-lg font-semibold drop-shadow">
                  {cat.name}
                </p>
              </div>
            </motion.div>
          ))}

        </div>
      )}

      {/* 📱 MOBILE SLIDER */}
      {isMobile && (
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop
          spaceBetween={14}
          slidesPerView={1.4} // 🔥 1 full + next 40%
        >
          {categories.map((cat, i) => (
            <SwiperSlide key={i}>
              <motion.div
                whileTap={{ scale: 0.96 }}
                onClick={() => navigate(`/product-category?category=${cat.query}`)}
                className="relative h-[140px] rounded-md overflow-hidden cursor-pointer"
              >

                <img
                  src={cat.img}
                  alt={cat.name}
                  className="w-full h-full object-cover"
                />

                <div className="absolute inset-0 bg-black/10" />

                <div className="absolute bottom-3 left-3">
                  <p className="text-white text-base font-semibold drop-shadow">
                    {cat.name}
                  </p>
                </div>

              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}

    </div>
  );
};

export default CategorySlider;
